export default __webpack_public_path__ + "static/media/include_16@3x.25c46c02.jpg";